import { ServiceLevel } from '~/lib/ApiModel';
import { IApiClient } from '~/lib/ApiClient';
import { AsyncStore } from './AsyncStore';
import { computed, makeObservable } from 'mobx';

export class ServiceLevelsStore extends AsyncStore<ServiceLevel[]> {
    constructor(apiClient: IApiClient) {
        super(() => apiClient.getServiceLevels(), []);
        makeObservable(this);
    }

    @computed
    get items() {
        return this.item;
    }
}
